import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export type SortByOption<T extends string> = { value: T; label: string };

export type SortByDropdownProps<T extends string> = {
  value: T;
  onChange: (value: T) => void;
  options: ReadonlyArray<SortByOption<T>>;
  labelId: string;
  label?: string;
  minWidth?: number;
};

export const SortByDropdown = <T extends string>({
  value,
  onChange,
  options,
  labelId,
  label = "Sort by",
  minWidth = 200,
}: SortByDropdownProps<T>) => (
  <FormControl size="small" sx={{ minWidth }}>
    <InputLabel id={labelId}>{label}</InputLabel>
    <Select
      labelId={labelId}
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value as T)}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
